function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 44.962,
  cy: 10.969,
  r: 5.2263
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.828,
  cy: 48.745,
  r: 5.2263
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.828,
  cy: 69.23,
  r: 5.2263
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.879,
  cy: 80.735,
  r: 5.2263
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 67.025,
  cy: 14.804,
  r: 5.2263
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 90.625,
  cy: 67.558,
  r: 5.2263
});

var SvgSegment = function SvgSegment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.49505,
    y: 0.49505,
    width: 99.01,
    height: 99.01,
    style: {
      fill: "none",
      imageRendering: "optimizeQuality",
      strokeWidth: 6,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6071 49.286 34.107-33.037 31.964 66.79 22.679-17.858",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.791 48.515 32.571-36.689",
    style: {
      fill: "none",
      strokeWidth: 5.9981,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.03 68.97 66.061 12",
    style: {
      fill: "none",
      strokeWidth: 5.9981,
      stroke: "#000"
    }
  }), _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.4284 -1.3714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.909 14.545 23.152 52.848",
    style: {
      fill: "none",
      strokeWidth: 5.9981,
      stroke: "#000"
    }
  }), _ref6, _ref7));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSegment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/segment.48b638c8.svg";
export { ForwardRef as ReactComponent };